/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-25 10:00:00                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-26 16:33:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * Validator
  * TechnicianForm: Create/edit technician form
*/

/* Imports */
import { t } from "i18next";
/***/

/* Services */
import TranslationEdit from "../translation-edit/TranslationEdit";
import { useEffect, useState } from "react";
import { api } from "../../../services/api/api";
import Switch from "../../switch/Switch";
/***/

/***/

/**
* TechnicianForm: Create/edit technician form 
* @param data - Data to edit
* @param onChange - On change event, trigger on field change
* @param onSubmit - On submit event, trigger enter key down on field
* @param submitted - is form submitted
*/
export default function WorkorderOriginForm({
  data,
  onChange,
  onSubmit,
  submitted
}: {
  data?: EasyTech.WorkorderOrigin,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean
}) {
    
  const [languages, setLanguagesState] = useState<EasyTech.Language[]>([]);
  
  /**
  * useEffect: get compinfos list
  */
  useEffect(() => {
    api.get("users/languages")
      .then(ret  => {
        setLanguagesState(ret as EasyTech.Language[]);        
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  /***/

  return (
    <>
      <div className="field">
        <label htmlFor="label">{t("label")}</label>
        <input type="text"
                value={data?.label || ""}
                onChange={(e) => onChange("label", e.target.value)}
                className={`${(submitted && (!data || !data?.label)) && "error"}`}
                placeholder={t("Label")}/>
      </div>

      <div className="field">
        <label htmlFor="translation">{t("Translation")}</label>
        <TranslationEdit key={data?.id} data={data?.translations} onChange={(v) => onChange("translations", v)} languages={languages}/>
      </div>

      <div className="field">
        <label className="block text-sm font-medium text-gray-700 mb-1">{t("Enable")}</label>
        <Switch checked={data?.enabled}
            onChange={(e) => onChange("enabled", e)}/>
      </div>
    </>
  );
}
/***/
